import { RetryPlugin } from "@module-federation/retry-plugin";

const retryPlugin = () =>
	RetryPlugin({
		retryTimes: 3,
		retryDelay: 1000,
	});

export default retryPlugin;
